// src/App.js - Ensure AuthProvider wraps everything
import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/layout/Navbar';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import Dashboard from './components/lending/LenderDashboard';
import ListDefaulter from './components/borrowing/ListDefaulter';
import ManageDefaulter from './components/borrowing/ManageDefaulter';
import PaymentPage from './pages/PaymentPage';
import ProfilePage from './pages/ProfilePage';
import PostsFeed from './components/posts/PostsFeed';

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <div className="min-h-screen bg-slate-950 text-slate-50 font-sans selection:bg-emerald-500/30">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/browse" element={<PostsFeed />} />
              
              <Route path="/dashboard" element={
                <ProtectedRoute requireEmailVerification={true}>
                  <Dashboard />
                </ProtectedRoute>
              } />
              
              <Route path="/list" element={
                <ProtectedRoute requiredRole="LENDER" requireEmailVerification={true}>
                  <ListDefaulter />
                </ProtectedRoute>
              } />
              
              <Route path="/manage/:id" element={
                <ProtectedRoute requireEmailVerification={true}>
                  <ManageDefaulter />
                </ProtectedRoute>
              } />
              
              <Route path="/payment/:id" element={
                <ProtectedRoute requireEmailVerification={true}>
                  <PaymentPage />
                </ProtectedRoute>
              } />
              
              <Route path="/profile" element={
                <ProtectedRoute requireEmailVerification={true}>
                  <ProfilePage />
                </ProtectedRoute>
              } />
            </Routes>
          </main>
          <footer className="bg-slate-900 border-t border-slate-800 py-8 text-center text-slate-500 text-sm">
            <p>&copy; {new Date().getFullYear()} PAYBACK Platform. All rights reserved.</p>
            <p className="mt-2 text-xs">A Peer-to-Peer Debt Recovery Network</p>
          </footer>
        </div>
      </AuthProvider>
    </Router>
  );
};

export default App;